import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import _ from 'lodash';
import { RouteModels } from '@share-models';

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {

  public buildBreadcrumbs(route: ActivatedRouteSnapshot, url = '', breadcrumbs: RouteModels.UiBreadCrumbItem[] = []): RouteModels.UiBreadCrumbItem[] {
    const breadcrumbsCopy = _.cloneDeep(breadcrumbs);
    if (route) {
      const routeUrl = route.url.map(segment => segment.path)
        .join('/');
      let nextUrl = routeUrl ? `${url}/${routeUrl}` : url;

      const routeDataBreadcrumb = route.data['breadcrumb'] as string;
      const additionalBreadcrumbs = (route.data['breadcrumbs'] ?? []) as RouteModels.UiBreadCrumbItem[]; // Add dynamic breadcrumbs

      // Add the static breadcrumb for this route
      if (routeDataBreadcrumb) {
        if (route.params['id']) {
          nextUrl = nextUrl.replace(route.params['id'] as string, '');
        }
        breadcrumbsCopy.push({ name: routeDataBreadcrumb, route: nextUrl });
      }

      // Add additional dynamic breadcrumbs if they exist
      for(const dynamicBreadcrumb of additionalBreadcrumbs) {
        breadcrumbsCopy.push(dynamicBreadcrumb);
      }

      // Check for child routes
      if (route.firstChild) {
        return this.buildBreadcrumbs(route.firstChild, nextUrl, breadcrumbsCopy);
      }
    }

    // Remove the URL from the last breadcrumb (if necessary)
    if (breadcrumbsCopy.length > 0) {
      if (breadcrumbsCopy[breadcrumbsCopy.length - 1].route) {
        breadcrumbsCopy[breadcrumbsCopy.length - 1].route = undefined;
      }
    }

    return breadcrumbsCopy;
  }

  public async updateBreadcrumb(route: ActivatedRoute, router: Router, breadcrumbs: {name: string, route?: string}[]): Promise<void> {
    route.snapshot.data['breadcrumbs'] = breadcrumbs;

    await router.navigate([], {
      relativeTo: route,
      queryParamsHandling: 'preserve',
    });
  }

}
